import React, {Component} from 'react';
import { connect } from 'react-redux';

class LoadingButton extends Component{

	render() {
		let componentClasses = 'btn btn-default';
		if(typeof this.props.classes !== 'undefined'){
			componentClasses = this.props.classes;
		}
		return (
				<button className={componentClasses} disabled='disabled'>{ this.loadSpinner() }</button>
		)
	}

	loadSpinner(){
		return (<img class="spinner" src="/wp-content/themes/isda-theme-underscores/images/ajax-loader.gif"/>);
	}




}


export default connect (null)(LoadingButton)